import React from 'react';
import { EyeIcon, CheckCircleIcon, ClockIcon, BookOpenIcon, CalendarIcon, ShieldCheck } from 'lucide-react';
const HeaderAdv2 = () => {
  return <header className="bg-white" style={{
    fontFamily: 'Georgia, Cambria, "Times New Roman", serif'
  }} data-id="element-17054" data-mp="2ch38aiqhghv3">
      {/* Top black bar */}
      <div className="bg-black h-3 w-full" data-id="element-17055" data-mp="22ie1bl04khtm"></div>

      {/* Masthead section */}
      <div className="border-b border-gray-800 px-4 sm:px-6 py-4 sm:py-6" data-id="element-17056" data-mp="22ki23u2q90po">
        <div className="text-center pb-3 sm:pb-4 mb-3 sm:mb-4" data-id="element-17057" data-mp="1xkc6y3x90w2u">
          <h2 className="font-serif text-2xl sm:text-3xl font-bold tracking-tight text-gray-900" data-id="element-17058" data-mp="1ss2iytfp2637">
            TRADITIONAL MEDPUB
          </h2>
          <div className="text-xs uppercase tracking-widest text-gray-500 mt-2 font-medium" data-id="element-17059" data-mp="1oomq886qwpvs">
            INDEPENDENT HEALTH INVESTIGATIONS SINCE 1982
          </div>
        </div>

        <div className="flex flex-col sm:grid sm:grid-cols-3 text-xs text-gray-600 border-b border-gray-300 pb-2 gap-1 sm:gap-0" data-id="element-17060" data-mp="1es1llnyn1gsh">
          <div className="text-left" data-id="element-17061" data-mp="19vt07stukrcv">VOL. 128, NO. 43</div>
          <div className="text-left sm:text-center" data-id="element-17062" data-mp="pead70h75hxr">
            {(() => {
            const yesterday = new Date();
            yesterday.setDate(yesterday.getDate() - 1);
            return yesterday.toLocaleDateString('en-US', {
              weekday: 'long',
              month: 'long',
              day: 'numeric',
              year: 'numeric'
            }).toUpperCase();
          })()}
          </div>
          <div className="text-left sm:text-right" data-id="element-17063" data-mp="18638j1jqnf8n">
            HEALTH & WELLNESS SECTION
          </div>
        </div>
      </div>

      {/* Article header */}
      <div className="px-4 sm:px-6 py-6 border-b border-gray-200" data-id="element-17064" data-mp="y85hy7eep6cv">
        <div className="max-w-4xl mx-auto" data-id="element-17065" data-mp="y9qfm5w0p5ey">
          <div className="uppercase text-xs tracking-wider text-gray-500 font-medium border-b border-gray-200 pb-2 mb-4" data-id="element-17066" data-mp="135fh4erlkwdw">
            INVESTIGATIVE REPORT
          </div>

          <h1 className="font-serif text-2xl sm:text-4xl font-bold text-gray-900 leading-tight mb-5" data-id="element-17067" data-mp="3nwftwaz2evps">
            Why Are So Many People on GLP-1 Getting Depressed—And Why Won't
            Anyone Talk About It?
          </h1>

          <div className="flex items-start mb-5 border-b border-gray-200 pb-5" data-id="element-17068" data-mp="1pfxbg3t29s9r">
            <div className="w-14 h-14 overflow-hidden rounded-full flex-shrink-0 mr-4 border border-gray-300" data-id="element-17069" data-mp="1knmdh6hvsgju">
              <img src="https://uploadthingy.s3.us-west-1.amazonaws.com/3QGeAdkaxHnkiYL33dUYdV/Tom_Parham.jpg" alt="Dr. Tom Parham" className="w-full h-full object-cover" data-id="element-17070" data-mp="1fo1c6pf8nw3y" />
            </div>
            <div className="flex-1" data-id="element-17071" data-mp="16o4s713snlf8">
              <div className="flex items-center" data-id="element-17072" data-mp="16n349w1oj4g3">
                <div className="font-medium text-gray-900 text-lg" data-id="element-17073" data-mp="11orwrryux611">
                  By Dr. Tom Parham, MD, FACE
                </div>
                <div className="ml-2 flex items-center text-blue-600" data-id="element-17074" data-mp="wrrp5cmczv7t">
                  <CheckCircleIcon className="h-4 w-4" data-id="element-17075" data-mp="2w3kr7no07qre" />
                  <span className="text-xs ml-1 font-medium" data-id="element-17076" data-mp="2w0yjno145b96">Verified</span>
                </div>
              </div>
              <div className="text-sm text-gray-600 mb-2" data-id="element-17077" data-mp="2ynqwbyoctn9j">
                Board-Certified Endocrinologist, 30 Years Clinical Practice
              </div>
              <div className="flex text-xs text-gray-500 items-center" data-id="element-17078" data-mp="33l95nq6aa4i2">
                <div className="flex items-center mr-4" data-id="element-17079" data-mp="38daf74c2hh4e">
                  <ClockIcon className="h-3 w-3 mr-1" data-id="element-17080" data-mp="38fwmd2v1pum3" />
                  <span data-id="element-17081" data-mp="3dbbwpktuh8dr">14 min read</span>
                </div>
                <div className="flex items-center" data-id="element-17082" data-mp="2fp4tofd6vo3i">
                  <EyeIcon className="h-3 w-3 mr-1" data-id="element-17083" data-mp="2fqpm9zfy0wyq" />
                  <span data-id="element-17084" data-mp="2kng3wr7ec0m9">31,542 views</span>
                </div>
              </div>
              <div className="flex items-center text-xs text-gray-500 mt-1" data-id="element-17085" data-mp="2pnc6cm0g3jzp">
                <ShieldCheck className="h-3.5 w-3.5 text-blue-600 mr-1 flex-shrink-0" data-id="element-17086" data-mp="2ppf5bvjksngk" />
                Medically Reviewed by{' '}
                <span className="text-blue-600 underline ml-1" data-id="element-17087" data-mp="4xczygz1tiz7">
                  Robert Hill, MD, FACP
                </span>
              </div>
            </div>
          </div>

          <p className="font-serif text-gray-700 text-base sm:text-lg mb-6 leading-relaxed border-l-4 border-gray-300 pl-4 italic" data-id="element-17088" data-mp="7h9otw45omou">
            After three decades in endocrinology, I've prescribed thousands of
            medications. But when patients on semaglutide started reporting
            severe depression—and regulatory agencies ignored it—I decided to
            run a 16-month investigation. What I discovered will save you
            sleepless nights - and might actually change your life.
          </p>

          <div className="border-t border-gray-200 pt-3 text-xs text-gray-500 flex flex-wrap justify-between" data-id="element-17089" data-mp="mf236kxyv51g">
            <div className="mb-1 flex items-center" data-id="element-17090" data-mp="1066xr8mh974x">
              <span className="font-medium mr-2" data-id="element-17091" data-mp="107rnmkxuk1wg">Published by:</span>
              Traditional Medicine Publications
            </div>
            <div className="mb-1 flex items-center" data-id="element-17092" data-mp="1a3l76o9zgvnq">
              <span className="font-medium mr-2" data-id="element-17093" data-mp="1a20hbbym60w7">Published:</span>
              {(() => {
              const yesterday = new Date();
              yesterday.setDate(yesterday.getDate() - 1);
              return yesterday.toLocaleDateString('en-US', {
                month: 'long',
                year: 'numeric'
              });
            })()}
            </div>
          </div>
        </div>
      </div>

      {/* Author image */}
      <div className="px-4 sm:px-8 py-6 border-b border-gray-200" data-id="element-17094" data-mp="1jr7dq41j4t2i">
        <div className="max-w-4xl mx-auto" data-id="element-17095" data-mp="1jtjtcajterce">
          <div className="sm:flex items-center" data-id="element-17096" data-mp="152klj1qt06tv">
            <div className="sm:w-1/3 mb-4 sm:mb-0 sm:mr-6" data-id="element-17097" data-mp="150q2jsz3eosf">
              <img src="https://uploadthingy.s3.us-west-1.amazonaws.com/3QGeAdkaxHnkiYL33dUYdV/Tom_Parham.jpg" alt="Dr. Tom Parham in medical office" className="w-full rounded-lg shadow-md" data-id="element-17098" data-mp="19ukqx9pn7rxu" />
            </div>
            <div className="sm:w-2/3" data-id="element-17099" data-mp="1120orza57589">
              <p className="text-sm text-gray-700 mb-2" data-id="element-17100" data-mp="m3ylzraxqns2">
                <span className="font-bold" data-id="element-17101" data-mp="m59s3xrus7mc">Dr. Tom Parham, MD, FACE</span> is a
                board-certified endocrinologist with 30 years of clinical
                experience specializing in diabetes management and metabolic
                disorders. Throughout his career, he has evaluated hundreds of
                pharmaceutical treatments and their long-term effects on
                patients.
              </p>
              <p className="text-sm text-gray-700" data-id="element-17102" data-mp="3ubwwcber4hfh">
                His investigative work focuses on identifying and solving
                medication side effects that fall through the cracks of official
                approval processes, helping patients achieve health outcomes
                without sacrificing quality of life.
              </p>
            </div>
          </div>
        </div>
      </div>
    </header>;
};
export default HeaderAdv2;